import React from "react";
import "./NotFound.css";

const NotFound = function() {
  return (
    <div className="not-found">
      <div className="text-center not-found-content">
        <h1> 404 </h1>
        <p>Sidan hittades inte</p>
      </div>
    </div>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/routes/NotFound/NotFound.jsx